import { TS_BonuscardSaving }   from '../TravelSeller/Models/TS_BonuscardSaving';
import { BookingItemInterface } from './BookingItemInterface';

export class BonuscardSaving extends TS_BonuscardSaving implements BookingItemInterface {
    
}